import { gql } from '@apollo/client'

import { TradeFragment } from './trade.fragment'
import { FormModelStructureFragment } from './form-model.fragment'
import { UserFragment } from './user.fragment'
import { PhaseFragment } from './phase.fragment'
import { CompanyFragment } from './company.fragment'
import { ProjectFileFragment } from './project.fragment'
import { ProjectFilePositionsFragment } from './project-file-positions.fragment'

export const FormFragment = gql`
  fragment FormFragment on Form {
    id
    createdDate
    idNumber
    name
    limitDate
    status
    trade {
      ...TradeFragment
    }
    phase {
      ...PhaseFragment
    }
    formModel {
      ...FormModelStructureFragment
    }
    author {
      ...UserFragment
    }
    company {
      ...CompanyFragment
    }
    projectFile {
      ...ProjectFileFragment
    }
    projectFilePositions {
      ...ProjectFilePositionsFragment
    }
  }
  ${TradeFragment}
  ${PhaseFragment}
  ${FormModelStructureFragment}
  ${UserFragment}
  ${CompanyFragment}
  ${ProjectFileFragment}
  ${ProjectFilePositionsFragment}
`

export const FormWithoutProjectFileFragment = gql`
  fragment FormWithoutProjectFileFragment on Form {
    id
    createdDate
    idNumber
    name
    limitDate
    status
    trade {
      ...TradeFragment
    }
    phase {
      ...PhaseFragment
    }
    author {
      ...UserFragment
    }
    company {
      ...CompanyFragment
    }
    projectFilePositions {
      ...ProjectFilePositionsFragment
    }
  }
  ${TradeFragment}
  ${PhaseFragment}
  ${UserFragment}
  ${CompanyFragment}
  ${ProjectFilePositionsFragment}
`
